<template>
  <div>
    <slot />
    <div class="flex gap-10">
      <RadioButton :title="firstTitle" :option="firstOption" @input="click" :value="getValue" :name="name"/>
      <RadioButton :title="secondTitle" :option="secondOption" @input="click" :value="getValue" :name="name"/>
    </div>
  </div>
</template>
<script>
import RadioButton from '@/components/RadioButton/RadioButton.vue';

export default {
  components: { RadioButton },
  props: {
    firstTitle: { type: String, required: true },
    secondTitle: { type: String, required: true },
    value: { type: Boolean, required: false },
    name: { type: String, required: true },
  },
  data() {
    return {
      firstOption: {
        value: true,
      },
      secondOption: {
        value: false,
      },
    };
  },
  methods: {
    click(option) {
      this.$emit('input', option.value === true);
    },
  },
  computed: {
    getValue() {
      if (this.value === true) {
        return this.firstOption;
      }

      if (this.value === false) {
        return this.secondOption;
      }

      return null;
    },
  },
};
</script>
